export interface ConfimationMessageProps {
    success?: boolean;
}

export const telegramLink = 'https://t.me/cfa_hub';
